import React from 'react';

const PromoAmbient: React.FC = () => (
  <div className="promo-ambient" aria-hidden="true">
    <div className="orb a" />
    <div className="orb b" />
    <div className="grid-move" />
  </div>
);

export default PromoAmbient;
